<template>
  <div id="header">
    <div v-if="!isLandingPage"
      :class="{ 'header-container': !displayTabMenu, 'header-container-with-nav': displayTabMenu }">
      <img class="header_logo" src="@Shared/assets/images/chc-logo.png" alt="Commerce Healthcare Logo" />
      <div class="header_current-flow-name">
        {{ flowName }}
        <span class="sup" v-show="checkFlowName">&reg;</span>
      </div>
      <div>
        <TabMenu v-if="displayTabMenu" :tabMenuItems="tabMenuItems" />
      </div>
    </div>
    <div v-else class="landing_page header-container">
      <img class="header_logo" src="@Shared/assets/images/chc-logo.png" alt="Commerce Healthcare Logo" />
    </div>
  </div>
</template>

<script>
import TabMenu from '../../OneTimePayment/src/components/Common/TabMenu/TabMenu.vue';
export default {
  name: "Header",
  components: {
    TabMenu
  },
  props: {
    displayTabMenu: {
      type: Boolean,
      default: false
    },
    tabMenuItems: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  computed: {
    flowName() {
      let routeFlowName = this.$route.meta.currentFlowName;

      return !!routeFlowName ? routeFlowName : "";
    },
    checkFlowName() {
      if (this.$route.meta.currentFlowName === "Enroll for HSF") {
        return true
      }
      return false
    },
    isLandingPage() {
      if (this.$route.meta.currentFlowName === "Landing Page") {
        return true
      }
      return false
    }
  }
};
</script>

<style lang="scss" scoped>
.sup {
  font-size: 50%;
  vertical-align: super;
  margin-left: -5px;
}

#header {
  height: 112px;
  background-color: #ffffff;
  border-bottom: 4px solid #ebedf0;
  z-index: 999;
  overflow: hidden;
  display: flex;
  align-items: center;

  @media (max-width: $grid-breakpoint-sm) {
    height: 70px;
  }

  .header-container {
    display: grid;
    align-items: center;
    //column-gap: 25px;
    
    @media (min-width: $grid-breakpoint-sm) {
      grid-template-columns: auto auto;
      margin-left: 7%;
    }
    @media (max-width: $grid-breakpoint-sm) {
      margin-top: 15px;
      grid-template-rows: auto auto;
    }
  }

  .header-container-with-nav {
    display: grid;
    grid-template-columns: 50% 50%;
    width: 100%;
    align-items: center;
    margin-left: 7%;

    .header_current-flow-name {
      display: none;
    }

    @media (max-width: $grid-breakpoint-sm) {
      gap: 5%;
    }
  }

  @media (max-width: $grid-breakpoint-sm) {
    display: flex;
    justify-content: center;
  }


  .header_content-wrapper {
    margin-top: 46px;

    @media (max-width: $grid-breakpoint-md) {
      margin-top: 42px;
    }
  }

  .header_logo {
    display: inline-block;
    max-width: 335px;
    // height: 100%;
    //margin-right: 22px;

    @media (max-width: $grid-breakpoint-md) {
      display: block;
    }

    @media (max-width: $grid-breakpoint-sm) {
      max-width: 231px;

    }
  }

  .header_current-flow-name {
    display: inline-block;
    color: $color_smokey-morning;
    font-size: 24px;
    font-weight: 600;
    font-family: Poppins;
    
    @media (min-width: $grid-breakpoint-md) {
      padding: 10px;
      margin-top: 10px;
    }
    @media (max-width: $grid-breakpoint-md) {
      display: block;
      font-size: 20px;
      margin-top: 10px;
    }

    @media (max-width: $grid-breakpoint-sm) {
      font-size: 16px;
    }
  }

  .header-link {
    display: inline-block;
    float: right;
    color: #43454d;
    font-family: Poppins;
    text-decoration: none;
    font-weight: bold;

    background: none;
    border: none;
    cursor: pointer;
  }
}
</style>